import common from './common';
import navigation from './navigation';
import dashboard from './dashboard';
import admin from './admin';
import auth from './auth';
import teleconsultation from './teleconsultation';
import notifications from './notifications';
import clinic from './clinic';

export default {
  common,
  navigation,
  dashboard,
  admin,
  auth,
  teleconsultation,
  notifications,
  clinic,
};
